<div class="flex flex-column gap-300">

  <nz-card nzHoverable style="max-width: 348px" *ngIf="isAsigning"
           (click)="toggleSelectedFilter()" [ngClass]="card.active ? 'active' : ''">
    <div class="flex gap-100" style="padding: 3px 0">
      <span class="text-label-14 text-dark text-semibold">{{ selectedEquipmentsIds.size }} Equipos seleccionados</span>
    </div>
  </nz-card>

  <!-- Fila de Input de busqueda y Filtros generales -->
  <div class="flex-center-between" style="position: relative;"
       [class.mb-32]="(isMobile$ | async)">

    <div *ngIf="(isMobile$ | async)" class="flex-center-between">

      <div *ngIf="(isMobile$ | async)" class="flex-center gap-100">
        <button (click)="toggleShowFilters()" class="text-btn-14" nz-button
                [nzType]="showFilters ? 'primary' : 'default'" nzShape="round" nzSize="default">
          <app-st-icon class="prefix" [name]="'filter_alt'" [bold]="true"></app-st-icon>
          <span>Filtros</span>
        </button>
      </div>
    </div>

    <div class="flex-center gap-150">

      <app-pocket-searchbar style="width: 100%"
                            [(searchValue)]="equipmentSearchValue"
                            [hideInput]="showFilters"
                            (showInputEvent)="showFilters = false"
                            (searchEvent)="filter()"></app-pocket-searchbar>

      <div [class.hidden]="(isMobile$ | async) && !showFilters" class="filters-cont flex-center gap-150">
        @for (filter of equipmentFilters; track filter.name) {
          <div nz-dropdown class="st-badget" [ngClass]="filter.active ? 'black' : 'subtle-grey'"
               [nzTrigger]="'click'"
               [nzDropdownMenu]="filter.name === 'Estado' ? stateMenu : typeMenu">
            <app-st-icon *ngIf="filter.icon !== ''" [name]="filter.icon"></app-st-icon>
            <label>{{ filter.name }}</label>
          </div>
        }
      </div>

      <!-- Menú desplegable para Estados -->
      <nz-dropdown-menu #stateMenu="nzDropdownMenu">
        <ul nz-menu>
          @for (state of equipmentStates; track state) {
            <li nz-menu-item (click)="setStateFilter(state)" [class.bg-grey-1]="state === equipmentStateFilterValue">
              {{ state }}
            </li>
          }
        </ul>
      </nz-dropdown-menu>

      <!-- Menú desplegable para Tipos -->
      <nz-dropdown-menu #typeMenu="nzDropdownMenu">
        <ul nz-menu>
          @for (type of equipmentTypes; track type) {
            <li nz-menu-item (click)="setTypeFilter(type)" [class.bg-grey-1]="type === equipmentTypeFilterValue">
              {{ type }}
            </li>
          }
        </ul>
      </nz-dropdown-menu>

    </div>
    <div class="flex-center gap-075">
      <button *ngIf="!isAsigning && !disableAsignEquipments && selectedEquipmentsIds.size > 0" class="flex-center gap-075" [nzShape]="(isMobile$ | async) ? 'circle' : 'round'"
              [nzSize]="'default'" nzDanger
              nz-button [nzType]="'default'"
              (click)="openUnassignConfirmation()">
        <app-st-icon *ngIf="(isMobile$ | async)" [color]="'#ec0909'" class="text-btn-16" [bold]="true" name="delete"></app-st-icon>
        <span *ngIf="!(isMobile$ | async)" class="text-btn-14">Desvincular</span>
      </button>
      <button *ngIf="!isAsigning && !disableAsignEquipments" class="flex-center gap-075" [nzShape]="(isMobile$ | async) ? 'circle' : 'round'"
              [nzSize]="'default'"
              nz-button [nzType]="(isMobile$ | async) ? 'default' : 'primary'" (click)="openAsignEquipmentDrawer()">
        <app-st-icon [class.prefix]="!(isMobile$ | async)" class="text-btn-16" [bold]="true" name="add"></app-st-icon>
        <span *ngIf="!(isMobile$ | async)" class="text-btn-14">Asignar equipos</span>
      </button>
      <a *ngIf="isAsigning && authService.loggedUser$.value?.viewMaestros" [href]="equipmetUrl" target="_blank">
        {{ (isMobile$ | async) ? 'Catálogos' : 'Gestionar maestro de equipos' }}
        <app-st-icon name="open_in_new"></app-st-icon>
      </a>
    </div>
  </div>
  @if (filteredEquiments && filteredEquiments.length > 0) {
    <nz-table #equipmentTbl [nzData]="filteredEquiments" [nzScroll]="{x: 'auto'}" class="st-bordered">
      <tr>
        @for (column of columns; track column) {
          <th *ngIf="!column.checkbox" [nzAlign]="column.align || null" style="white-space: nowrap"
              [style.min-width]="column.name === 'Documentación' ? 'max-content' : undefined"
              [class.sorteable-column]="column.sortable"
              [style.width]="column.width ? (column.width + 'px') : 'auto'">
            {{ column.name }}
            <app-st-th-sort *ngIf="column.sortable"
                           [sortDirection]="getColumnSortDirection(column)"
                           (sortEvent)="column.sortFn && column.sortFn()"></app-st-th-sort>
          </th>
          <th *ngIf="column.checkbox" nzAlign="center"
              [style.width]="column.width ? (column.width + 'px') : 'auto'">
            <label nz-checkbox [nzIndeterminate]="isIndeterminate"
                   (nzCheckedChange)="toggleSelectAllEquipments()"
                   [nzChecked]="isAllSelected"></label>
          </th>
        }
        <th style="width: 76px" [nzRight]="(isMobile$ | async) ? false : '0px'"></th>
      </tr>
      <tbody>
        @for (equip of equipmentTbl.data; track equip.id) {
          <tr>
            <td nzAlign="center">
              <label nz-checkbox (nzCheckedChange)="toggleSelectEquipment(equip.id)" class="top-0"
                     [nzDisabled]="isAsigning && !equip.isActive"
                     [nzChecked]="selectedEquipmentsIds.has(equip.id)"></label>
            </td>
            <td>
              <ng-container *ngIf="equip.image && !isThisEquipmentWIthErrorImg(equip.id); else iconFallback">
                <img
                  alt="eq_img"
                  [src]="equip.image"
                  (error)="handleImageError(equip.id)"
                  style="object-fit: contain; width: 16px; height: 16px"
                >
              </ng-container>
              <ng-template #iconFallback>
                <app-st-icon [name]="equip.equipmentTypeId.toString() | equipmentIcon" ></app-st-icon>
              </ng-template>

              <span [class.color-grey-9]="!equip.equipmentType?.name">{{ equip.equipmentType?.name || '-' }}</span>
            </td>
            <td [class.color-grey-9]="!equip.name">{{ equip.name || '-' }}</td>
            <!--          <td>-->
            <!--            <div style="padding: 6px 8px" class="st-badget" [ngClass]="equip.isActive ? 'subtle-green' : 'subtle-grey'">-->
            <!--              <label>{{equip.isActive ? 'Activo' : 'Inactivo'}}</label>-->
            <!--            </div>-->
            <!--          </td>-->
            <td>
              @if (getItemById(equip.ownerId, partnerList); as owner) {
                <div style="width: fit-content" class="avatar-badge">
                  <nz-avatar class="flex-shrink-0" [nzSize]="23" [nzSrc]="getSafeImageUrl(owner?.avatar)"></nz-avatar>
                  <span
                    class="text-label-12 text-dark text-semibold text-nowrap">{{ owner?.name }} {{ owner?.surName }}</span>
                </div>
              } @else {
                <span class="color-grey-9">-</span>
              }
            </td>
            <td>
              @if (getItemById(equip.contactId, partnerList); as contact) {
                <div style="width: fit-content" class="avatar-badge">
                  <nz-avatar class="flex-shrink-0" [nzSize]="23" [nzSrc]="getSafeImageUrl(contact?.avatar)"></nz-avatar>
                  <span
                    class="text-label-12 text-dark text-semibold text-nowrap">{{ contact?.name }} {{ contact?.surName }}</span>
                </div>
              } @else {
                <span class="color-grey-9">-</span>
              }
            </td>
            <td>
              @if (!equip.documents?.length) {
                <!--  Si el equipo no tiene asociado ningun documento se muestra un boton para subir alguno  -->
                <button *ngIf="!!authService.loggedUser$.value?.uploadDocumentsUnlimited || !!authService.loggedUser$.value?.uploadDocumentsLimited"
                        (click)="openUploadDocsModal(equip.id, 'Equipment', equip)" class="empty-doc-btn" nz-button
                        nzSize="small" nzType="default">
                  <app-st-icon class="prefix" name="file_copy_off"></app-st-icon>
                  <span>Vacío</span>
                  <app-st-icon class="sufix" name="upload"></app-st-icon>
                </button>
              } @else {
                <div class="flex gap-150" style="align-items: center">
                  <!--  Si el equipo tiene asociado 1 o mas documentos se muestra el nombre del 1er doc de la lista  -->
                  <ng-container *ngIf="equip.documents && equip.documents!.length > 0">
                    <app-doc-badget-status [document]="equip.documents![0]!"
                                           (deleteEvent)="deleteDocument(equip, equip.documents![0]!)">
                    </app-doc-badget-status>
                  </ng-container>

                  <!--  Si el equipo tiene asociado 2 o mas documentos se muestra el nombre del 2do doc de la lista  -->
                  <ng-container *ngIf="equip.documents!.length! > 1">
                    <app-doc-badget-status [document]="equip.documents![1]!"
                                           (deleteEvent)="deleteDocument(equip, equip.documents![1]!)">
                    </app-doc-badget-status>
                  </ng-container>

                  <!--  Si el equipo tiene asociado 3 o mas documentos se muestran la cantidad de documentos restantes -->
                  <div *ngIf="equip.documents!.length! > 2" class="st-badget subtle-grey large">
                    <label>+ {{ equip.documents!.length! - 2 }}</label>
                  </div>
                </div>
              }
            </td>
            <td nzAlign="center" class="action-cell" [nzRight]="(isMobile$ | async) ? false : '0px'">
              <button *ngIf="!isAsigning" nz-button nzType="text" nzShape="circle" nzSize="default" nz-dropdown
                      [nzDropdownMenu]="actionMenu" nzTrigger="click" [nzPlacement]="'bottomRight'">
                <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
              </button>
              <button (click)="openEquipmentDetailDrawer(equip)" nz-button nzType="text" nzShape="circle"
                      nzSize="default">
                <app-st-icon name="right_panel_open" [bold]="true"></app-st-icon>
              </button>
            </td>

            <nz-dropdown-menu #actionMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="openUnassignEquipmentConfirmation(equip.id)">
                  <button class="flex-center gap-100"
                          nz-button nzType="text" nzShape="circle" nzSize="default">
                    <app-st-icon name="delete" [bold]="true"></app-st-icon>
                    <span class="text-label-14 text-dark">Desvincular</span>
                  </button>
                </li>
              </ul>
            </nz-dropdown-menu>
          </tr>
        }
      </tbody>
    </nz-table>
  }
</div>

<!-- Template para notificaciones toast -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
             [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>

<app-confirmation-modal #confirmationModal (confirmed)="onUnassignConfirmed($event)"></app-confirmation-modal>
